module.exports = __webpack_public_path__ + "static/media/DraftJS.a1161381.md";